<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'Jump',
  data () {
    return {}
  },
  created() {
    var target = 'List'
    var params = {}
    var category = this.$route.query.category;
    if (category != undefined) {
        params.category = category
    }
    var timeline = this.$route.query.timeline;
    if (timeline != undefined) {
        params.timeline = timeline
    }
    var search = this.$route.query.search;
    if (search != undefined) {
        params.item = search
        target = 'Search'
    }
    var page = this.$route.query.page;
    if (page != undefined) {
        params.page = page
    }
    this.$router.push({
      name: target,
      query: params
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Jump.vue